type CampaignsNavWorkspace = {
    _id?: string
    isBusiness?: boolean
    campaignsEnabled?: boolean
} | null | undefined

const restrictCampaignsTo1M =
    (process.env.REACT_APP_ENABLE_CAMPAIGNS_ONLY_FOR_1M_WORKSPACE ?? 'false').toLowerCase() === 'true'

const oneMWorkspaceId = process.env.REACT_APP_1M_WORKSPACE_ID

const is1MWorkspace = (workspace: CampaignsNavWorkspace) =>
    !!oneMWorkspaceId && !!workspace?._id && String(workspace._id) === String(oneMWorkspaceId)

export const shouldShowCampaignsNavItem = (workspace: CampaignsNavWorkspace) => {
    if (!restrictCampaignsTo1M) return true
    return is1MWorkspace(workspace)
}

/** Trial, Business plan, or admin-enabled campaigns flag. */
export const hasCampaignsPlanAccess = (workspace: CampaignsNavWorkspace, trial: boolean) =>
    trial || !!workspace?.isBusiness || !!workspace?.campaignsEnabled

/**
 * Full campaigns visibility/access check (nav, routes, simulation).
 * When REACT_APP_ENABLE_CAMPAIGNS_ONLY_FOR_1M_WORKSPACE=true, ONLY the 1M workspace may access campaigns — no exceptions.
 */
export const hasCampaignsAccess = (workspace: CampaignsNavWorkspace, trial: boolean) => {
    if (restrictCampaignsTo1M) return is1MWorkspace(workspace)
    return hasCampaignsPlanAccess(workspace, trial)
}
